export function toHumanReadableDate(current, splitter = ".") {
    const d = new Date(current);
    const dStr = `${d.getDate()}${splitter}${d.getMonth() + 1}${splitter}${d.getFullYear()} ${
        d.getHours() >= 10 ? d.getHours() : "0" + d.getHours()
    }:${d.getMinutes() >= 10 ? d.getMinutes() : "0" + d.getMinutes()}`;
    return dStr;
}
